import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {txnInitSplitList_template} from "../components/templates/txnInitSplitList_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class txnInitSplit extends vnModule_knockoutJS{

    public XHRHdl: XMLHttpRequestHandler;
    protected txnInitSplitList: txnInitSplitList_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "txnInitSplit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.txnInitSplitList = new txnInitSplitList_template("txnInitSplitList", this.viewModel, this);

        return [this.txnInitSplitList.build()];
    }

    public fillPage() : void {
        this.getListData();
    }

    protected viewTxnInitSplit(idBrand, idUser){
        page('/txn_init_split/brand/'+idBrand+'/user/'+idUser+'/view');
    }

    protected addTxnInitSplit(): void {

        page('/txn_init_split/edit');
    }

    protected paginationOnPageClick(): void {
        this.getListData();
    }

    public txnInitSplitListReorder(): void {
        this.getListData();
    }

    /**
     *
     * @protected
     */
    protected filterSimpleOnChange(): void {
        this.txnInitSplitList.resetPageNumber();
        this.getListData();
    }

    /**
     *
     * @protected
     */
    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }


    /**
     * @protected
     */
    protected getListData(): void {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.txnInitSplitList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/txn_init_split/getList';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.txnInitSplitList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    public dataReorder(id) {

        this.getListData();
    }
    /**
     *
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function {
        return function(){
            obj.manageResponse(req, obj, function(){
                if (req.request.status == 200) {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            obj.loadingOut(obj.txnInitSplitList.builtTemplate.children.namedItem("list-results"));
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any): void {

        this.txnInitSplitList.setTxnInitSplits(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.txnInitSplitList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.txnInitSplitList.setPaginationTotalCount(responseParsed.totalCount);
    }

    protected filterDropdownOnChange(): void {
        this.getListData();
    }

    protected deleteSplit(): void {

        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(this.txnInitSplitList.getViewModelForRequest())] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/txn_init_split/delete', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onDeleteReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onDeleteReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Transaction intitiative split deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.getListData();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/txnInitSplit.ts